import React, { useState } from "react";
import { ReactComponent as ExpandIcon } from "Assets/Icons/Leaderboard/ExpandIcon.svg";
import { ReactComponent as CollapseIcon } from "Assets/Icons/Leaderboard/CollapseIcon.svg";
import { ReactComponent as AlertIcon } from "Assets/Icons/Leaderboard/AlertIcon.svg";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Grid2,
  IconButton,
  Link,
  Typography,
} from "@mui/material";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import { useSelector } from "react-redux";

const Instructions = () => {
  const [isOpen, setIsOpen] = useState(false);

  const { Translation } = useSelector((state) => ({
    Translation: state.Translation.translation?.Course || {},
  }));

  return (
    <Accordion
      elevation={0}
      bordered
      expanded={isOpen}
      onChange={() => setIsOpen(!isOpen)}
    >
      <AccordionSummary
        expandIcon={
          <IconButton filled>
            {" "}
            <PrimaryIcon
              color="white"
              icon={isOpen ? CollapseIcon : ExpandIcon}
              width="16px"
              height="16px"
            />{" "}
          </IconButton>
        }
      >
        <Typography
          display={"flex"}
          alignItems={"center"}
          gap="10px"
          fontWeight={500}
          variant="subtitle"
        >
          <PrimaryIcon icon={AlertIcon} width="20px" height="20px" />{" "}
          {Translation?.Instructions}
        </Typography>{" "}
      </AccordionSummary>
      <AccordionDetails
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          "& .info": {
            padding: "16px",
            background: "#FFF7E8",
          },
        }}
      >
        <Grid2 spacing={2} container>
          <Grid2 size={6}>
            <Typography fontWeight={500} variant="subtitle">
              {Translation?.PreReadSection}
            </Typography>
            <Typography>
              {Translation?.PreReadSectionDescription}
            </Typography>
            <Typography>{Translation?.FewInstructionsBegin}</Typography>
            <Typography>
              <ol dangerouslySetInnerHTML={{__html: Translation?.AssignmentProblemList}}>
                {/* <li>
                  Please complete going through the Pre-read content before the{" "}
                  <Link href="#" underline="hover">
                    live session
                  </Link>{" "}
                  for this class starts.
                </li>
                <li>
                  Once the live session is over please solve{" "}
                  <Link href="#" underline="hover">
                    assignment problems.
                  </Link>{" "}
                </li> */}
              </ol>
            </Typography>
          </Grid2>
          <Grid2 size={6}>
            <Typography fontWeight={500} variant="subtitle">
              {Translation?.GeneralRules}
            </Typography>
            <Typography>
              <ol dangerouslySetInnerHTML={{__html: Translation?.GeneralRuleDescription}}>
                {/* <li>
                  All submissions are automatically checked for plagiarism, and
                  flagged solutions might not be counted toward the total score.
                </li>
                <li>
                  Do not hesitate to discuss the solution with your peers or to
                  request help from your TAs.
                </li>
                <li>
                  DO NOT move on from a problem until you have understood the
                  approach very well.
                </li>
                <li>
                  Plagiarism defeats the purpose of learning a new pattern or
                  concept.
                </li> */}
              </ol>
            </Typography>
          </Grid2>
        </Grid2>
        <Box className="info">
          <Typography variant="subtitle" fontWeight={500}>
            {Translation?.ScoreReduction}
          </Typography>
          <Typography color="secondary.light">
            {Translation?.YourScoreReducedUseHints}
          </Typography>
          <Typography color="secondary.light">
            <ol dangerouslySetInnerHTML={{__html: Translation?.ScoreReductionDescription}}>
              {/* <li>Hint 1 - 10% reduction</li>
              <li>Hint 2 - 20% reduction</li>
              <li>Hint 3 - 30% reduction (and so on)</li>
              <li>Solution Approach - 50% reduction</li>
              <li>Complete Solution - 100% reduction</li>{" "}
              <li>Video Hint - 0% reduction</li> */}
            </ol>
          </Typography>
          <Typography
            variant="subtitle"
            fontWeight={500}
            color="secondary.light"
          >
            {Translation?.ProblemReductionNote}
          </Typography>
        </Box>
        <Box className="info">
          <Typography variant="subtitle" fontWeight={500}>
            {Translation?.PartialScoring}
          </Typography>
          <Typography color="secondary.light">
            {Translation?.PartialScoringDescription}
          </Typography>
          <Typography
            variant="subtitle"
            fontWeight={500}
            color="secondary.light"
          >
            {Translation?.ForExam}
          </Typography>
          <Typography color="secondary.light">
            {Translation?.ScoreProblemDescription}
          </Typography>
          <Typography
            variant="subtitle"
            fontWeight={500}
            color="secondary.light"
          >
            {Translation?.SequentialManner}
          </Typography>
          <Typography color="secondary.light">
            {Translation?.SequentialMannerDescription}
          </Typography>
        </Box>
        <Box className="info">
          <Typography variant="subtitle" fontWeight={500}>
            {Translation?.ObjectiveQuestions}
          </Typography>
          <Typography color="secondary.light">
            {Translation?.ObjectiveQuestionsDescription}
          </Typography>
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default Instructions;
